import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const AngLoader = ({ className }) => {
  return (
    <span className={classnames(`small_loader`, className)}>
      <span className="dot_1" />
      <span className="dot_2" />
    </span>
  );
};

AngLoader.propTypes = {
  className: PropTypes.string,
};

export default AngLoader;
